// document.addEventListener("DOMContentLoaded", function () {
//   const swiperEl = document.querySelector(".slider-with-dots.product__media-list.media_size-portrait.js-media-list.swiper.no-js-hidden.swiper-initialized.swiper-vertical.swiper-autoheight.swiper-backface-hidden");

//   if (swiperEl && swiperEl.swiper) {
//     const swiperInstance = swiperEl.swiper;

//     swiperInstance.params.mousewheel = {
//       forceToAxis: true,
//       releaseOnEdges: false,
//       sensitivity: 1,
//       thresholdDelta: 20,
//       thresholdTime: 200,
//     };
 

//     swiperInstance.params.touchReleaseOnEdges = false;
//     swiperInstance.params.touchRatio = 0.2;
//     swiperInstance.params.longSwipes = true;
//     swiperInstance.params.freeMode = false;


//     swiperInstance.on("slideChangeTransitionStart", function () {
//       if (typeof changeNavStyle === "function") changeNavStyle();
//     });

//     swiperInstance.on("reachEnd", function () {
//       setTimeout(() => {
//         swiperInstance.params.mousewheel.releaseOnEdges = true;
//       }, 600);
//     });

//     swiperInstance.on("reachBeginning", function () {
//       setTimeout(() => {
//         swiperInstance.params.mousewheel.releaseOnEdges = true;
//       }, 600);
//     });

//     swiperInstance.on("fromEdge", function () {
//       swiperInstance.params.mousewheel.releaseOnEdges = false;
//     });

//     // 🧩 New Fix: Activate wheel listener immediately after load
//     setTimeout(() => {
//       swiperEl.dispatchEvent(new Event("mouseenter"));
//       swiperEl.dispatchEvent(new WheelEvent("wheel", { deltaY: 0 }));
//     }, 1000); // wait 1s for swiper to initialize fully

//     swiperInstance.update();
//   }
// });



// document.addEventListener("DOMContentLoaded", function () {
//   const productOuter = document.querySelector(".product__outer");
//   const swiperEl = productOuter?.querySelector(".product__media-list.swiper");

//   if (!swiperEl || !swiperEl.swiper) return;

//   const swiperInstance = swiperEl.swiper;

//   // Mousewheel config
//   swiperInstance.params.mousewheel = {
//     forceToAxis: true,
//     releaseOnEdges: true, // important so page can scroll after swiper ends
//     sensitivity: 1,
//     thresholdDelta: 20,
//     thresholdTime: 200,
//   };

//   swiperInstance.params.touchReleaseOnEdges = true;
//   swiperInstance.params.touchRatio = 0.2;
//   swiperInstance.params.longSwipes = true;
//   swiperInstance.params.freeMode = false;

//   swiperInstance.on("slideChangeTransitionStart", function () {
//     if (typeof changeNavStyle === "function") changeNavStyle();
//   });

//   // 🧩 Handle mousewheel scroll on both sides
//   productOuter.addEventListener("wheel", function (e) {
//     const isAtEnd = swiperInstance.isEnd;
//     const isAtStart = swiperInstance.isBeginning;

//     // Scroll down
//     if (e.deltaY > 0 && !isAtEnd) {
//       e.preventDefault();
//       swiperInstance.slideNext();
//     }
//     // Scroll up
//     else if (e.deltaY < 0 && !isAtStart) {
//       e.preventDefault();
//       swiperInstance.slidePrev();
//     }
//     // Else (reached end or start) → allow page scroll
//   });

//   swiperInstance.update();
// });


// document.addEventListener("DOMContentLoaded", function () {
//   const productOuter = document.querySelector(".product__outer");
//   const swiperEl = productOuter?.querySelector(".product__media-list.swiper");

//   if (!swiperEl || !swiperEl.swiper) return;

//   const swiperInstance = swiperEl.swiper;

//   // Swiper mousewheel config
//   swiperInstance.params.mousewheel = {
//     forceToAxis: true,
//     releaseOnEdges: true, // allow page scroll when ends reached
//     sensitivity: 1,
//     thresholdDelta: 20,
//     thresholdTime: 200,
//   };

//   swiperInstance.params.touchReleaseOnEdges = true;
//   swiperInstance.params.touchRatio = 0.2;
//   swiperInstance.params.longSwipes = true;
//   swiperInstance.params.freeMode = false;

//   swiperInstance.on("slideChangeTransitionStart", function () {
//     if (typeof changeNavStyle === "function") changeNavStyle();
//   });

//   // 🧩 Handle mousewheel scroll on both sides — smooth & one by one
//   let scrollTimeout = null;
//   productOuter.addEventListener("wheel", function (e) {
//     const isAtEnd = swiperInstance.isEnd;
//     const isAtStart = swiperInstance.isBeginning;

//     // Prevent too fast scrolling (add small delay)
//     if (scrollTimeout) return;
//     scrollTimeout = setTimeout(() => (scrollTimeout = null), 400); // 400ms delay

//     if (e.deltaY > 0 && !isAtEnd) {
//       e.preventDefault();
//       swiperInstance.slideNext(500); // smooth next slide (500ms transition)
//     } else if (e.deltaY < 0 && !isAtStart) {
//       e.preventDefault();
//       swiperInstance.slidePrev(500); // smooth previous slide
//     }
//     // Allow page scroll if start or end reached
//   });

//   swiperInstance.update();
// });

// For only desktop swip hota ha but mob mai issue ha

// document.addEventListener("DOMContentLoaded", function () {
//   const productOuter = document.querySelector(".product__outer");
//   const swiperEl = productOuter?.querySelector(".product__media-list.swiper");

//   if (!swiperEl || !swiperEl.swiper) return;

//   const swiperInstance = swiperEl.swiper;

//   // Swiper basic settings
//   swiperInstance.params.mousewheel = {
//     forceToAxis: true,
//     releaseOnEdges: true,
//     sensitivity: 1,
//     thresholdDelta: 20,
//     thresholdTime: 200,
//   };

//   swiperInstance.params.touchReleaseOnEdges = true;
//   swiperInstance.params.touchRatio = 0.2;
//   swiperInstance.params.longSwipes = true;
//   swiperInstance.params.freeMode = false;

//   swiperInstance.on("slideChangeTransitionStart", function () {
//     if (typeof changeNavStyle === "function") changeNavStyle();
//   });

//   // 🧩 Fixed smooth scroll logic (page won't move until swiper ends)
//   let scrollTimeout = null;

//   productOuter.addEventListener(
//     "wheel",
//     function (e) {
//       const isAtEnd = swiperInstance.isEnd;
//       const isAtStart = swiperInstance.isBeginning;

//       // Prevent page scroll during image scrolling
//       if (!(isAtEnd && e.deltaY > 0) && !(isAtStart && e.deltaY < 0)) {
//         e.preventDefault();
//       }

//       // Avoid multiple fast scrolls
//       if (scrollTimeout) return;
//       scrollTimeout = setTimeout(() => (scrollTimeout = null), 400);

//       if (e.deltaY > 0 && !isAtEnd) {
//         swiperInstance.slideNext(500);
//       } else if (e.deltaY < 0 && !isAtStart) {
//         swiperInstance.slidePrev(500);
//       }
//     },
//     { passive: false } // important to allow preventDefault
//   );

//   swiperInstance.update();
// });

// sahi ha but mob thora sa issue ha abhe bhe

// document.addEventListener("DOMContentLoaded", function () {
//   const productOuter = document.querySelector(".product__outer");
//   const swiperEl = productOuter?.querySelector(".product__media-list.swiper");
//   if (!swiperEl || !swiperEl.swiper) return;

//   const swiperInstance = swiperEl.swiper;

//   // --- Base Swiper Config ---
//   swiperInstance.params.mousewheel = {
//     forceToAxis: true,
//     releaseOnEdges: true,
//     sensitivity: 1,
//   };

//   swiperInstance.params.touchReleaseOnEdges = true;
//   swiperInstance.params.touchRatio = 0.25;
//   swiperInstance.params.longSwipes = true;
//   swiperInstance.params.freeMode = false;

//   // --- Desktop Scroll Control ---
//   let scrollTimeout = null;
//   productOuter.addEventListener(
//     "wheel",
//     function (e) {
//       const isAtEnd = swiperInstance.isEnd;
//       const isAtStart = swiperInstance.isBeginning;

//       if (!(isAtEnd && e.deltaY > 0) && !(isAtStart && e.deltaY < 0)) {
//         e.preventDefault();
//       }

//       if (scrollTimeout) return;
//       scrollTimeout = setTimeout(() => (scrollTimeout = null), 400);

//       if (e.deltaY > 0 && !isAtEnd) {
//         swiperInstance.slideNext(400);
//       } else if (e.deltaY < 0 && !isAtStart) {
//         swiperInstance.slidePrev(400);
//       }
//     },
//     { passive: false }
//   );

//   // --- Mobile Touch Control ---
//   let startY = 0;
//   let endY = 0;
//   let touchLocked = false;

//   productOuter.addEventListener("touchstart", (e) => {
//     startY = e.touches[0].clientY;
//   });

//   productOuter.addEventListener("touchmove", (e) => {
//     endY = e.touches[0].clientY;
//   });

//   productOuter.addEventListener("touchend", () => {
//     if (touchLocked) return; // prevent spam
//     touchLocked = true;
//     setTimeout(() => (touchLocked = false), 300); // delay between slides

//     const diff = startY - endY;
//     const threshold = 50; // adjust sensitivity

//     if (Math.abs(diff) > threshold) {
//       if (diff > 0 && !swiperInstance.isEnd) {
//         swiperInstance.slideNext(1000);
//       } else if (diff < 0 && !swiperInstance.isBeginning) {
//         swiperInstance.slidePrev(1000);
//       }
//     }
//   });

//   swiperInstance.update();
// });

// abhe yehi wala
// document.addEventListener("DOMContentLoaded", function () {
//   const productOuter = document.querySelector(".product__outer");
//   const swiperEl = productOuter?.querySelector(".product__media-list.swiper");

//   if (!swiperEl || !swiperEl.swiper) return;

//   const swiperInstance = swiperEl.swiper;

//   // Swiper settings
//   swiperInstance.params.mousewheel = {
//     forceToAxis: true,
//     releaseOnEdges: true,
//     sensitivity: 1,
//     thresholdDelta: 20,
//     thresholdTime: 200,
//   };

//   swiperInstance.params.touchReleaseOnEdges = true;
//   swiperInstance.params.touchRatio = 0.2;
//   swiperInstance.params.longSwipes = true;
//   swiperInstance.params.freeMode = false;

//   swiperInstance.on("slideChangeTransitionStart", function () {
//     if (typeof changeNavStyle === "function") changeNavStyle();
//   });

//   let scrollTimeout = null;

//   // ✅ Add scroll only if screen width > 1000px
//   function handleScrollLogic() {
//     if (window.innerWidth > 1000) {
//       // desktop only behavior
//       productOuter.addEventListener(
//         "wheel",
//         onWheelScroll,
//         { passive: false }
//       );
//     } else {
//       // remove the event on smaller screens
//       productOuter.removeEventListener("wheel", onWheelScroll);
//     }
//   }

//   function onWheelScroll(e) {
//     const isAtEnd = swiperInstance.isEnd;
//     const isAtStart = swiperInstance.isBeginning;

//     // Prevent page scroll during swiper scroll
//     if (!(isAtEnd && e.deltaY > 0) && !(isAtStart && e.deltaY < 0)) {
//       e.preventDefault();
//     }

//     if (scrollTimeout) return;
//     scrollTimeout = setTimeout(() => (scrollTimeout = null), 400);

//     if (e.deltaY > 0 && !isAtEnd) {
//       swiperInstance.slideNext(500);
//     } else if (e.deltaY < 0 && !isAtStart) {
//       swiperInstance.slidePrev(500);
//     }
//   }

//   // Run once on load
//   handleScrollLogic();

//   // ✅ Recheck on window resize
//   window.addEventListener("resize", handleScrollLogic);

//   swiperInstance.update();
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const productOuter = document.querySelector(".product__outer");
//   const swiperEl = productOuter?.querySelector(".product__media-list.swiper");

//   if (!swiperEl || !swiperEl.swiper) return;

//   const swiperInstance = swiperEl.swiper;

//   // --- Swiper Base Config ---
//   swiperInstance.params.mousewheel = {
//     forceToAxis: true,
//     releaseOnEdges: false, // we'll manage manually
//     sensitivity: 1,
//     thresholdDelta: 20,
//     thresholdTime: 200,
//   };
//   swiperInstance.params.touchReleaseOnEdges = true;
//   swiperInstance.params.touchRatio = 0.2;
//   swiperInstance.params.longSwipes = true;
//   swiperInstance.params.freeMode = false;

//   swiperInstance.on("slideChangeTransitionStart", function () {
//     if (typeof changeNavStyle === "function") changeNavStyle();
//   });

//   let scrollTimeout = null;
//   let edgeReached = false;

//   function onWheelScroll(e) {
//     const isAtEnd = swiperInstance.isEnd;
//     const isAtStart = swiperInstance.isBeginning;

//     // prevent page scroll while inside swiper range
//     if (!edgeReached) e.preventDefault();

//     // avoid rapid triggers
//     if (scrollTimeout) return;
//     scrollTimeout = setTimeout(() => (scrollTimeout = null), 400);

//     if (e.deltaY > 0 && !isAtEnd) {
//       swiperInstance.slideNext(500);
//     } else if (e.deltaY < 0 && !isAtStart) {
//       swiperInstance.slidePrev(500);
//     }

//     // Edge handling — page scroll allow after next wheel only
//     if ((e.deltaY > 0 && isAtEnd) || (e.deltaY < 0 && isAtStart)) {
//       if (!edgeReached) {
//         edgeReached = true;
//         setTimeout(() => (edgeReached = false), 800);
//       }
//     } else {
//       edgeReached = false;
//     }
//   }

//   // ✅ Apply scroll on both: outer + inner containers
//   function bindScrollHandlers() {
//     [productOuter, swiperEl].forEach((el) => {
//       el.removeEventListener("wheel", onWheelScroll);
//       el.addEventListener("wheel", onWheelScroll, { passive: false });
//     });
//   }

//   // ✅ Enable only for desktop
//   function handleScrollLogic() {
//     if (window.innerWidth > 1000) {
//       bindScrollHandlers();
//     } else {
//       [productOuter, swiperEl].forEach((el) =>
//         el.removeEventListener("wheel", onWheelScroll)
//       );
//     }
//   }

//   handleScrollLogic();
//   window.addEventListener("resize", handleScrollLogic);

//   swiperInstance.update();
// });






















document.addEventListener("DOMContentLoaded", function () {
  const productOuter = document.querySelector(".product__outer");
  const swiperEl = productOuter?.querySelector(".product__media-list.swiper");

  if (!swiperEl || !swiperEl.swiper) return;

  const swiperInstance = swiperEl.swiper;

  // --- Base Swiper config (unchanged) ---
  swiperInstance.params.mousewheel = {
    forceToAxis: true,
    releaseOnEdges: false, // we'll manage edge-release manually
    sensitivity: 1,
    thresholdDelta: 20,
    thresholdTime: 200,
  };
  swiperInstance.params.touchReleaseOnEdges = true;
  swiperInstance.params.touchRatio = 0.2;
  swiperInstance.params.longSwipes = true;
  swiperInstance.params.freeMode = false;

  swiperInstance.on("slideChangeTransitionStart", function () {
    if (typeof changeNavStyle === "function") changeNavStyle();
  });

  let scrollTimeout = null;
  let edgeReached = false;

  // --- main outer wheel handler (one-by-one slide) ---
  function onWheelScroll(e) {
    const isAtEnd = swiperInstance.isEnd;
    const isAtStart = swiperInstance.isBeginning;

    // prevent page scroll while we're moving slides (unless edgeReached)
    if (!edgeReached) e.preventDefault();

    // avoid rapid triggers
    if (scrollTimeout) return;
    scrollTimeout = setTimeout(() => (scrollTimeout = null), 400);

    if (e.deltaY > 0 && !isAtEnd) {
      swiperInstance.slideNext(500);
    } else if (e.deltaY < 0 && !isAtStart) {
      swiperInstance.slidePrev(500);
    }

    // Edge handling — set flag so next scroll can go to page
    if ((e.deltaY > 0 && isAtEnd) || (e.deltaY < 0 && isAtStart)) {
      if (!edgeReached) {
        edgeReached = true;
        setTimeout(() => (edgeReached = false), 800);
      }
    } else {
      edgeReached = false;
    }
  }

  // Bind/unbind helpers
  function bindOuterWheel() {
    productOuter.removeEventListener("wheel", onWheelScroll);
    productOuter.addEventListener("wheel", onWheelScroll, { passive: false });
  }
  function unbindOuterWheel() {
    productOuter.removeEventListener("wheel", onWheelScroll);
  }

  // --- inside-swiper wheel listener (only while mouse is inside swiper) ---
  // This allows page scroll after a small delay when user scrolls beyond edge inside the swiper
  function onSwiperEdgeWheel(e) {
    const isAtEnd = swiperInstance.isEnd;
    const isAtStart = swiperInstance.isBeginning;

    // if at end and user scrolls down => allow a small page scroll after delay
    if (isAtEnd && e.deltaY > 0) {
      // small debounce so it doesn't fire too eagerly
      setTimeout(() => {
        // scroll page a little — user did intent to scroll page
        window.scrollBy({ top: 100, behavior: "smooth" });
      }, 300);
      return;
    }

    // if at start and user scrolls up => scroll page up a bit after delay
    if (isAtStart && e.deltaY < 0) {
      setTimeout(() => {
        window.scrollBy({ top: -100, behavior: "smooth" });
      }, 300);
      return;
    }

    // otherwise do nothing — allow Swiper to handle the event natively
  }

  // mouseenter / mouseleave toggles
  function onMouseEnterSwiper() {
    // when mouse is inside swiper area: let Swiper control wheel (so unbind outer)
    unbindOuterWheel();
    // attach a lightweight listener on swiper to detect edge scroll for page move
    swiperEl.addEventListener("wheel", onSwiperEdgeWheel, { passive: true });
  }

  function onMouseLeaveSwiper() {
    // when mouse leaves swiper area: re-bind our outer wheel handler
    swiperEl.removeEventListener("wheel", onSwiperEdgeWheel);
    bindOuterWheel();
  }

  // Initialize: apply desktop-only behavior
  function handleScrollLogic() {
    if (window.innerWidth > 1000) {
      // default: outer handles wheel
      bindOuterWheel();
      // add mouse enter/leave on swiper area
      swiperEl.addEventListener("mouseenter", onMouseEnterSwiper);
      swiperEl.addEventListener("mouseleave", onMouseLeaveSwiper);
    } else {
      // mobile: remove these desktop handlers
      unbindOuterWheel();
      swiperEl.removeEventListener("mouseenter", onMouseEnterSwiper);
      swiperEl.removeEventListener("mouseleave", onMouseLeaveSwiper);
      swiperEl.removeEventListener("wheel", onSwiperEdgeWheel);
    }
  }

  // Run once and on resize
  handleScrollLogic();
  window.addEventListener("resize", handleScrollLogic);

  swiperInstance.update();
});


















